<template>
  <v-alert v-model="showAlert" :type="type.type" prominent border="left">
    <h4 class="body mb-2">{{type.title}}</h4>
    <h4 class="body-2" v-for="(message, key) in messages" :key="key">{{message}}</h4>
  </v-alert>
</template>

<script>
import { mapMutations, mapState } from "vuex";

export default {  
  methods: {
    ...mapMutations("alert", ["toggleAlert"])
  },
  computed: {
    ...mapState("alert", ["messages", "type"]),
    showAlert: {
      get() {
        return this.$store.state.alert.show;
      },
      set(val) {
        this.toggleAlert(val);
      }
    }
  }
};
</script>

